import {
  alias,
  brand,
  fontSize,
  semanticDark,
  semanticLight,
  shadow,
} from "./tokens";
import { fontFamily } from "./fonts";

/**
 * The videos render on the light theme. Every scene
 * reads from `theme` so switching here cascades everywhere — no local
 * overrides needed. Use `darkTheme` below if a dark surface is needed.
 */
export const theme = {
  semantic: semanticLight,
  alias,
  brand,
  fontSize,
  fontFamily,
  fontWeight: brand.typography.fontWeight,
  shadow,
} as const;

export type Theme = typeof theme;

/**
 * Exposed alongside `theme` so a scene can temporarily swap palettes
 * (e.g. a white outro over a dark intro) without re-deriving tokens.
 */
export const lightTheme = { ...theme, semantic: semanticLight } as const;
export const darkTheme = { ...theme, semantic: semanticDark } as const;
